module.exports = __webpack_public_path__ + "img/p6.eee03859.png";